export default {
  'pages.layouts.userLayout.title': 'AI Dovut — лоиҳаи JURAT барои таҳлил ва тавлиди мундариҷа',
  'pages.login.accountLogin.tab': 'Воридшавӣ',
  'pages.login.tab.login': 'Воридшавӣ',
  'pages.login.accountLogin.errorMessage': 'Логин/парол нодуруст аст',
  'pages.login.failure': 'Воридшавӣ номуваффақ шуд, кӯшиш кунед!',
  'pages.login.success': 'Воридшавӣ муваффақ!',
  'pages.login.login.label': 'Логин',
  'pages.login.login.placeholder': 'Логинро ворид кунед',
  'pages.login.login.required': 'Логинро ворид кунед!',
  'pages.login.login.invalid': 'Формати логин нодуруст аст!',
  'pages.login.password.label': 'Парол',
  'pages.login.password.placeholder': 'Паролро ворид кунед',
  'pages.login.password.required': 'Паролро ворид кунед!',
  'pages.login.password.min': 'На камтар аз 6 аломат',
  'pages.login.password.max': 'На бештар аз 20 аломат',
  'pages.getCaptchaSecondText': 'сон',
  'pages.login.rememberMe': 'Дар ёд доштан',
  'pages.login.forgotPassword': 'Фаромӯш кардед?',
  'pages.login.submit': 'Ворид шудан',
  'pages.login.loginWith': 'Ворид шудан бо:',
  'pages.login.registerAccount': 'Сабти ном',
  // Welcome page
  'pages.monitoring.communications': 'Ҷустуҷӯи коммуникатсияҳо',
  'pages.monitoring.communicationDetails': 'Маълумоти коммуникатсияҳо',
  'pages.monitoring.focus': 'Аз омор кушода шуд: {user}',
  'pages.welcome.stats.title': 'Омори чат',
  'pages.welcome.stats.users': 'Корбарони чат',
  'pages.welcome.stats.avgResponse': 'Вақти миёнаи ҷавоб',
  'pages.welcome.stats.textRequests': 'Дархостҳои матнӣ',
  'pages.welcome.stats.voiceRequests': 'Дархостҳои овозӣ',
  'pages.welcome.stats.dynamics': 'Дархостҳо аз рӯи рӯзҳо',
  'pages.welcome.stats.tooltip': 'матн {text}, овоз {voice}',
  'pages.welcome.stats.period': 'Давра: {from} — {to}',
  'pages.welcome.stats.loadError': 'Омори чат бор карда нашуд',
  'pages.welcome.stats.seconds': 'с',
  'pages.welcome.recentUsers.title': 'Дархостҳои охирин',
  'pages.welcome.recentUsers.empty': 'Ҳанӯз ба чат дархост нашудааст',
  'pages.welcome.recentUsers.requests': 'Дархостҳо дар давра',
  'pages.welcome.recentUsers.channel.text': 'Матн',
  'pages.welcome.recentUsers.channel.voice': 'Овоз',
  'pages.welcome.title': 'Хулоса',
  'pages.welcome.description':
    'Хулосаи чат: корбарон, вақти ҷавоб, дархостҳои матнӣ ва овозӣ, муроҷиатҳои охирин.',
  'pages.school.title': 'Мактаб',
  'pages.school.description':
    'Кишвар, минтақа, шаҳр, мактаб, нақш ва профилро пайдарпай интихоб кунед. Интихоб захира мешавад ва ба чат ҳамчун параметр меравад.',
  'pages.school.country': 'Кишвар',
  'pages.school.region': 'Минтақа',
  'pages.school.city': 'Шаҳр',
  'pages.school.school': 'Мактаб',
  'pages.school.role': 'Нақш',
  'pages.school.class': 'Синф',
  'pages.school.employee': 'Корманд',
  'pages.school.student': 'Хонанда',
  'pages.school.subject': 'Фан',
  'pages.school.profile': 'Корбар',
  'pages.school.placeholder': 'Интихоб кунед',
  'pages.school.saved': 'Интихоби захирашуда',
  'pages.school.savedHint': 'Ин JSON ҳамроҳ бо савол ба чат фиристода мешавад.',
  'pages.school.empty': 'Ҳеҷ чиз интихоб нашудааст',
  'pages.school.clear': 'Тоза кардани интихоб',
  'pages.school.loadError': 'Боркунии маълумоти мактаб ноком шуд',
  'pages.school.role.teacher': 'омӯзгор',
  'pages.school.role.student': 'хонанда',
  'pages.school.role.parent': 'волидайн',
  'pages.school.role.director': 'директор',
  'pages.school.role.class_teacher': 'роҳбари синф',
  'pages.school.role.employee': 'корманд',
  'pages.welcome.chatInfo.title': 'Пайваст кардани чат',
  'pages.welcome.chatInfo':
    'Метавонед чатро ба ҳар саҳифа бо ворид кардани ChatDialog илова кунед.',
  'pages.welcome.chatFeatures.title': 'Имконоти чат',
  'pages.welcome.chatFeatures.textMessages': 'Фиристодани паёмҳои матнӣ',
  'pages.welcome.chatFeatures.fileUpload': 'Боргузории файлҳо',
  'pages.welcome.chatFeatures.messageHistory': 'Таърихи паёмҳо',
  'pages.welcome.chatFeatures.autoScroll': 'Гузариши худкор ба охирин паём',
  'pages.welcome.chatFeatures.modalWindow': 'Равзанаи модалӣ барои истифодаи қулай',
  'pages.welcome.organization.title': 'Ташкилоти ҷорӣ',
  'pages.welcome.organization.select': 'Ташкилотро интихоб кунед',
  'pages.welcome.organization.empty': 'Барои ин корбар ягон ташкилот ё контекст дастрас нест',
  'pages.welcome.organization.fallback': 'Ташкилот',
  'pages.welcome.organization.loadFailed': 'Боркунии контекстҳои ташкилот иҷро нашуд',
  'pages.welcome.organization.switchSuccess': 'Контексти ташкилот иваз шуд',
  'pages.welcome.organization.switchFailed': 'Иваз кардани контексти ташкилот муяссар нашуд',
  // List page
  'pages.list.uploadFiles': 'Боргирии файлҳо',
  'pages.list.uploading': 'Дар ҳоли боргирӣ...',
  'pages.list.uploadedFiles': 'Файлҳои боргиришуда',
  'pages.list.download': 'Боргирӣ',
  // Signup
  'pages.signup.tab': 'Сабти ном',
  'pages.signup.login.placeholder': 'Логинро ворид кунед',
  'pages.signup.login.required': 'Логинро ворид кунед!',
  'pages.signup.login.invalid': 'Формати логин нодуруст!',
  'pages.signup.name.label': 'Ном',
  'pages.signup.name.placeholder': 'Номи шумо чист?',
  'pages.signup.name.required': 'Номро ворид кунед!',
  'pages.signup.name.max': 'Ном аз 50 аломат зиёд нашавад',
  'pages.signup.password.placeholder': 'Паролро ворид кунед',
  'pages.signup.password.required': 'Паролро ворид кунед!',
  'pages.signup.password.min': 'На камтар аз 6 аломат',
  'pages.signup.password.max': 'На бештар аз 20 аломат',
  'pages.signup.confirmPassword.label': 'Паролро такрор кунед',
  'pages.signup.confirmPassword.placeholder': 'Паролро ворид кунед',
  'pages.signup.confirmPassword.required': 'Паролро такрор кунед!',
  'pages.signup.confirmPassword.mismatch': 'Паролҳо мувофиқат намекунанд!',
  'pages.signup.submit': 'Сабти ном',
  'pages.signup.success': 'Бомуваффақият сабт шуд!',
  'pages.signup.failure': 'Хатои сабти ном, аз нав кӯшиш кунед!',
  // 404 page
  'pages.404.subTitle': 'Бубахшед, саҳифа вуҷуд надорад.',
  'pages.404.buttonText': 'Ба саҳифаи асосӣ',
  // Идораи корбарон
  'pages.users.loading': 'Боркунии маълумоти корбар...',
  'pages.users.fetchError': 'Боркунии корбарон иҷро нашуд',
  'pages.users.noUserData': 'Маълумоти корбар дастрас нест',
  'pages.users.userInformation': 'Маълумоти корбар',
  'pages.users.accountCreated': 'Эҷоди ҳисоб',
  'pages.users.lastUpdated': 'Навсозии охирин',
  'pages.users.title': 'Идораи корбарон',
  'pages.users.welcome': 'Хуш омадед, {name}! Корбарон ва танзимоти системаро идора кунед.',
  'pages.users.status': 'Ҳолат',
  'pages.users.actions': 'Амалҳо',
  'pages.users.user': 'Корбарон',
  'pages.users.active': 'Фаъол',
  'pages.users.inactive': 'Ғайрифаъол',
  'pages.users.editUser': 'Вироиши корбар',
  'pages.users.updateUser': 'Навсозии корбар (бо ID)',
  'pages.users.deleteUser': 'Нест кардани корбар (бо ID)',
  'pages.users.userIdRequired': 'Рақами корбарро ворид кунед',
  'pages.users.userIdPlaceholder': 'Рақами корбарро ворид кунед',
  'pages.users.deleteConfirm': 'Оё шумо мутмаин ҳастед, ки ин корбарро нест мекунед?',
  'pages.users.passwordPlaceholder': 'Барои нигоҳ доштани пароли ҷорӣ холӣ гузоред',
  'pages.users.emailPlaceholder': 'Почтаи электрониро ворид кунед',
  'pages.users.emailRequired': 'Лутфан почтаи электрониро ворид кунед',
  'pages.users.emailInvalid': 'Формати почтаи электронӣ нодуруст аст',
  'pages.users.nameRequired': 'Лутфан номро ворид кунед',
  'pages.users.roleRequired': 'Лутфан нақшро интихоб кунед',
  'pages.users.createNotImplemented': 'Функсияи эҷод ҳанӯз амалӣ нашудааст',
  'pages.users.totalUsers': 'Ҳамагӣ корбарон',
  'pages.users.statsError': 'Боркунии омор иҷро нашуд',
  'pages.users.noMore': 'Корбарони бештар нест',
  'pages.users.joined': 'Ҳамроҳ шуд',
  'pages.usersCards.title': 'Корбарон (Кортҳо)',
  'pages.usersCards.welcome': 'Хуш омадед, {name}! Корбаронро дар намуди кортӣ бинед.',
  'pages.usersCards.totalUsers': 'Ҳамагӣ корбарон',
  'pages.usersCards.statsError': 'Боркунии омори корбарон иҷро нашуд',
  'pages.usersCards.fetchError': 'Боркунии корбарон иҷро нашуд',
  'pages.usersCards.loading': 'Боркунии корбарон...',
  'pages.usersCards.noMore': 'Корбарони бештар нест',
  'pages.usersCards.empty': 'Ягон корбар ёфт нашуд',

  // Идораи нақшҳо
  'pages.roles.title': 'Идораи нақшҳо',
  'pages.roles.role': 'Нақшҳо',
  'pages.roles.actions': 'Амалҳо',
  'pages.roles.createRole': 'Эҷоди нақш',
  'pages.roles.editRole': 'Вироиши нақш',
  'pages.roles.updateRole': 'Навсозии нақш (бо ID)',
  'pages.roles.deleteRole': 'Нест кардани нақш (бо ID)',
  'pages.roles.roleIdRequired': 'Рақами нақшро ворид кунед',
  'pages.roles.roleIdPlaceholder': 'Рақами нақшро ворид кунед',
  'pages.roles.deleteConfirm': 'Оё шумо мутмаин ҳастед, ки ин нақшро нест мекунед?',
  'pages.roles.namePlaceholder': 'Номи нақшро ворид кунед',
  'pages.roles.slugPlaceholder': 'Слаги нақшро ворид кунед (масалан, admin, user)',
  'pages.roles.nameRequired': 'Лутфан номи нақшро ворид кунед',
  'pages.roles.slugRequired': 'Лутфан слаги нақшро ворид кунед',
  'pages.roles.admin': 'Мудир',
  'pages.roles.user': 'Корбар',

  // Идораи намудҳои субъект
  'pages.subjectTypes.title': 'Идораи намудҳои субъект',
  'pages.subjectTypes.actions': 'Амалҳо',
  'pages.subjectTypes.createSubjectType': 'Эҷоди намуди субъект',
  'pages.subjects.createSubject': 'Эҷоди субъект',
  'pages.searchTable.requiredField': 'Майдони ҳатмӣ',
  'pages.subjectTypes.updateSubjectType': 'Навсозии намуди субъект (бо subject_type_id)',
  'pages.subjectTypes.editSubjectType': 'Вироиши намуди субъект',
  'pages.subjectTypes.subjectTypeIdRequired': 'Рақами намуди субъектро ворид кунед',
  'pages.subjectTypes.subjectTypeIdPlaceholder': 'Рақами намуди субъектро ворид кунед',
  'pages.subjectTypes.subjectTypeIdDeletePlaceholder':
    'Барои нест кардан рақами намуди субъектро ворид кунед',
  'pages.subjectTypes.deleteSubjectType': 'Нест кардани намуди субъект (бо subject_type_id)',
  'pages.subjectTypes.deleteConfirm': 'Оё мутмаин ҳастед, ки ин намуди субъектро нест мекунед?',
  'pages.subjectTypes.namePlaceholder': 'Номи намуди субъектро ворид кунед',
  'pages.subjectTypes.slugPlaceholder': 'Слаги намуди субъектро ворид кунед',
  'pages.subjectTypes.nameRequired': 'Лутфан номи намуди субъектро ворид кунед',
  'pages.subjectTypes.slugRequired': 'Лутфан слаги намуди субъектро ворид кунед',

  // Идораи ташкилотҳо
  'pages.organizations.title': 'Идораи ташкилотҳо',
  'pages.organizations.organizationIdRequired': 'Рақами субъектро ворид кунед',
  'pages.organizations.organizationIdPlaceholder': 'Рақами субъектро ворид кунед',
  'pages.organizations.organizationIdDeletePlaceholder':
    'Барои нест кардан рақами ташкилотро ворид кунед',
  'pages.organizations.actions': 'Амалҳо',
  'pages.organizations.createOrganization': 'Эҷоди ташкилот',
  'pages.organizations.updateOrganization': 'Навсозии ташкилот',
  'pages.organizations.editOrganization': 'Вироиши ташкилот',
  'pages.organizations.deleteOrganization': 'Нест кардани ташкилот',
  'pages.organizations.deleteConfirm': 'Оё мутмаин ҳастед, ки ин ташкилотро нест мекунед?',
  'pages.organizations.loadError':
    'Бор кардани ташкилотҳо муваффақ нашуд: хатои сервер (organization.type бояд объект бошад).',
  'pages.organizations.detailsPlaceholder': '{"key":"value"}',
  'pages.organizations.detailsRequired': 'Лутфан details-ро дар формати JSON ворид кунед',

  // Амалҳои умумӣ дар ҷадвалҳо
  'pages.searchTable.new': 'Нав',
  'pages.searchTable.edit': 'Вироиш',
  'pages.searchTable.delete': 'Нест кардан',
  'pages.searchTable.reset': 'Танзими дубора',
  'pages.searchTable.query': 'Ҷустуҷӯ',
  'pages.searchTable.yes': 'Ҳа',
  'pages.searchTable.no': 'Не',
  'pages.searchTable.ok': 'OK',
  'pages.searchTable.cancel': 'Бекор кардан',
  'pages.searchTable.createSuccess': 'Бомуваффақият эҷод шуд',
  'pages.searchTable.createError': 'Хатогӣ ҳангоми эҷод',
  'pages.searchTable.updateSuccess': 'Бомуваффақият нав карда шуд',
  'pages.searchTable.updateError': 'Хатогӣ ҳангоми навсозӣ',
  'pages.searchTable.deleteSuccess': 'Бомуваффақият нест карда шуд',
  'pages.searchTable.deleteError': 'Хатогӣ ҳангоми нест кардан',
  'pages.searchTable.okWithCount': 'OK ({count})',
  'pages.searchTable.totalRange': '{start}-{end} аз {total} сабт',
  'pages.searchTable.deleteInputRequired': '{field}-ро ворид кунед',
  'pages.searchTable.deleteInputPlaceholder': 'Барои нест кардан шиносномаро ворид кунед',

  // Placeholders
  'pages.searchTable.inputPlaceholder': 'Лутфан ворид кунед',
  'pages.searchTable.selectPlaceholder': 'Лутфан интихоб кунед',

  // @generated entity-pages
  'pages.aiModel.createAiModel': 'Эҷоди модели ИИ',
  'pages.application.createApplication': 'Эҷоди барнома',
  'pages.brokerEvent.createBrokerEvent': 'Эҷоди рӯйдади брокер',
  'pages.communication.createCommunication': 'Эҷоди коммуникатсия',
  'pages.communicationDetail.createCommunicationDetail': 'Эҷоди тафсилоти коммуникатсия',
  'pages.communicationFolder.createCommunicationFolder': 'Эҷоди ҷӯрчуби коммуникатсия',
  'pages.communicationHistory.createCommunicationHistory': 'Эҷоди таърихи коммуникатсия',
  'pages.communicationPermission.createCommunicationPermission': 'Эҷоди иҷозоти коммуникатсия',
  'pages.communicationStrategy.createCommunicationStrategy': 'Эҷоди стратегияи коммуникатсия',
  'pages.communicationSubject.createCommunicationSubject': 'Эҷоди субъекти коммуникатсия',
  'pages.communicationVersion.createCommunicationVersion': 'Эҷоди насхи коммуникатсия',
  'pages.communicationView.createCommunicationView': 'Эҷоди намоиши коммуникатсия',
  'pages.contextClassifier.createContext': 'Эҷоди синфкунандаи контекст',
  'pages.contextData.createContextData': 'Эҷоди маълумоти контекст',
  'pages.contextPipeline.createContextPipeline': 'Эҷоди нақбаи контекст',
  'pages.contextStorage.createContextStorage': 'Эҷоди захираи контекст',
  'pages.dataPipeline.createDataPipeline': 'Эҷоди нақби маълумот',
  'pages.dataPipelineDetail.createDataPipelineDetail': 'Эҷоди тафсилоти нақби маълумот',
  'pages.dependentVersionService.createDependentVersionService': 'Эҷоди вобастагии насх',
  'pages.detailScheduler.createDetailScheduler': 'Эҷоди элементи иҷрои ҷадвал',
  'pages.division.createDivision': 'Эҷоди қисмот',
  'pages.groupContextClassifier.createGroupContextClassifiers': 'Эҷоди гӯруҳи синфкунандаҳо',
  'pages.historyRunningPipeline.createHistoryRunningPipeline': 'Эҷоди таърихи иҷрои нақб',
  'pages.historyRunningStreamPipeline.createHistoryRunningStreamPipeline':
    'Эҷоди таърихи услуби ҷараён',
  'pages.individual.createIndividual': 'Эҷоди шахси воқеӣ',
  'pages.injectionVersionService.createInjectionVersionService': 'Эҷоди инъекцияи версияи хидмат',
  'pages.organization.createOrganization': 'Эҷоди ташкилот',
  'pages.organizationPosition.createOrganizationPosition': 'Эҷоди вазифа дар ташкилот',
  'pages.organizationStructure.createOrganizationStructure': 'Эҷоди сохтори созмонӣ',
  'pages.organizationStructurePermission.createOrganizationStructurePermissions':
    'Эҷоди дастрасӣ ба сохтор',
  'pages.permission.createPermission': 'Эҷоди иҷозат',
  'pages.pipeline.createPipeline': 'Эҷоди нақби коркард',
  'pages.providerContext.createProviderContext': 'Эҷоди контексти таъминкунанда',
  'pages.providerContextClassifier.createProviderContextClassifiers':
    'Эҷоди синфкунандаи контексти таъминкунанда',
  'pages.resultContextClassifier.createResultContextClassifiers': 'Эҷоди натиҷа — синфкунанда',
  'pages.resultScheduler.createResultScheduler': 'Эҷоди натиҷаи ҷадвал',
  'pages.role.createRole': 'Эҷоди нақш',
  'pages.running.createRunning': 'Эҷоди намуди иҷро',
  'pages.scheduler.createScheduler': 'Эҷоди ҷадвалгузор',
  'pages.schemaPipeline.createSchemaPipeline': 'Эҷоди схемаи нақб',
  'pages.service.createService': 'Эҷоди хизматрасонӣ',
  'pages.serviceBuild.createBuildServiceVersionResponse': 'Эҷоди service Build',
  'pages.serviceEvent.createServiceEvent': 'Эҷоди рӯйдади хизматрасонӣ',
  'pages.serviceParams.createServiceParams': 'Эҷоди параметрҳои хизматрасонӣ',
  'pages.serviceRun.createRunServiceVersionResponse': 'Эҷоди service Run',
  'pages.serviceType.createServiceType': 'Эҷоди намуди хизматрасонӣ',
  'pages.serviceVersion.createServiceVersion': 'Эҷоди насхи хизматрасонӣ',
  'pages.serviceVersionBuild.createBuildServiceVersionResponse': 'Эҷоди service Version Build',
  'pages.serviceVersionRun.createRunServiceVersionResponse': 'Эҷоди service Version Run',
  'pages.shareContextStorage.createShareContextStorage': 'Эҷоди захираи умумии контекст',
  'pages.subject.createSubject': 'Эҷоди субъект',
  'pages.subjects.createSubject': 'Эҷоди subjects',
  'pages.subjectType.createSubjectType': 'Эҷоди намуди субъект',
  'pages.subjectTypes.createSubjectType': 'Эҷоди намуди субъект',
  'pages.testPipeline.createTestPipeline': 'Эҷоди нақби санҷиш',
  'pages.testResultPipeline.createTestResultPipeline': 'Эҷоди натиҷаи санҷиш',
  'pages.tuneModel.createTuneModel': 'Эҷоди вазифаи қайчӣ',
  'pages.tuneModelResult.createTuneModelResult': 'Эҷоди натиҷаи қайчии модел',
  'pages.typeProviderContext.createTypeProviderContexts': 'Эҷоди намуди контексти таъминкунанда',
  'pages.typeSubjectCommunication.createTypeSubjectCommunication':
    'Эҷоди намуди субъекти коммуникатсия',
  'pages.user.createUser': 'Эҷоди корбар',
  'pages.userContext.createUserContextItem': 'Эҷоди контексти корбар',
  'pages.userOrganizationStructure.createUserOrganizationStructure': 'Эҷоди корбар дар сохтор',
  'pages.versionProviderContext.createVersionProviderContext':
    'Эҷоди насхи контексти таъминкунанда',
};
